module.exports = new __parcel__URL__("customers.9a9a469e.html").toString();